
import { defineComponent, ref } from 'vue';
import Editor from '@/components/code/Editor.vue';

export default defineComponent({
  name: 'codemirrorpage',
  components: {
    Editor,
  },

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  setup(props: any, { emit }: any) {
    const editorele = ref({});
    const code = ref<string>('a = "Hello Word!"');
    const mode = 'python';

    const sendMessage = () => {
      emit('send-message');
    };
    return {
      code,
      editorele,
      mode,
      sendMessage,
    };
  },
});
